import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VTooltip from "v-tooltip";
import vSelect from "vue-select";
import Autocomplete from "@trevoreyre/autocomplete-vue";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

Vue.use(VTooltip);
Vue.use(Autocomplete);
VTooltip.options.defaultTrigger = "click";
Vue.component("v-select", vSelect);
